import { render, staticRenderFns } from "./Masks.vue?vue&type=template&id=207a2dfc&scoped=true"
import script from "./Masks.vue?vue&type=script&lang=ts"
export * from "./Masks.vue?vue&type=script&lang=ts"
import style0 from "./Masks.vue?vue&type=style&index=0&id=207a2dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a2dfc",
  null
  
)

export default component.exports